import { User } from '@/api/types/public';
import { ProviderType, TrackingEvent } from '../types';

export function loginAdapter(
  data: { userInfo: User },
  provider: ProviderType,
  eventId?: string,
): TrackingEvent | TrackingEvent[] | null {
  const { userInfo } = data;
  switch (provider) {
    case ProviderType.GA4:
      return {
        eventName: 'login',
        eventId,
        properties: { method: 'Popup' },
      };
    case ProviderType.APPLOVIN: {
      const aleid = localStorage.getItem('zl_axon_aleid');
      return {
        eventName: 'generate_lead',
        eventId,
        properties: {
          user_id: `${userInfo.id}&${aleid}`,
        },
      };
    }
    case ProviderType.SNOWPLOW:
      return {
        eventName: 'Login_Result',
        eventId,
        properties: {
          user_id: String(userInfo?.id || ''),
        },
      };
    default:
      return null;
  }
}
